import Cookies from 'js-cookie'

$(window).on('advertisementpwa:open', function (event, key) {
  console.log('advertisementpwa:open', key)
  const $content = $(`.js-advertisementpwa--content[data-key="${key}"]`)
  $content.removeClass('d-none').removeClass('inactive').addClass('active')
})


$(window).on('advertisementpwa:close', function (event, key) {
  console.log('advertisementpwa:close', key)
  const $content = $(`.js-advertisementpwa--content[data-key="${key}"]`)
  $content.addClass('inactive').removeClass('active')
})


$(document).on('turbolinks:load', function () {

  const isPWA = window.matchMedia('(display-mode: standalone)').matches
  const isDashboard = location.pathname.indexOf('/dashboard') === 0
  const isClosedPast = Cookies.get('advertisementpwa:close') !== undefined

  // console.log(isPWA)
  if (!isPWA && !isDashboard && !isClosedPast) {
    setTimeout(function () {
      if (navigator.userAgent.indexOf('Android') > 0) {
        $(window).trigger('advertisementpwa:open', ['android']);
      } else if (navigator.userAgent.indexOf('iPhone') > 0) {
        $(window).trigger('advertisementpwa:open', ['iphone']);
      }
    }, 30 * 1000);
  }

  $('.js-advertisementpwa--close').on('click', function (event) {
    event.preventDefault();
    let key = $(this).data('key')
    $(window).trigger('advertisementpwa:close', [key]);
    // Cookies.set('advertisementpwa:close', Date.now(), { expires: 10/86164 })
    Cookies.set('advertisementpwa:close', Date.now(), { expires: 7 })
  })
});
